import { unwrap, unwrapVoid } from '../http.js';
import { paginate } from '../pagination.js';
export function createPostsApi(client) {
    async function comments(id, query) {
        return unwrap(await client.GET('/v1/posts/{id}/comments', {
            params: { path: { id }, query: query ?? {} },
        }));
    }
    return {
        async create(body) {
            return unwrap(await client.POST('/v1/posts', { body }));
        },
        async get(id) {
            return unwrap(await client.GET('/v1/posts/{id}', { params: { path: { id } } }));
        },
        async remove(id) {
            unwrapVoid(await client.DELETE('/v1/posts/{id}', { params: { path: { id } } }));
        },
        async like(id) {
            return unwrap(await client.POST('/v1/posts/{id}/like', { params: { path: { id } } }));
        },
        async unlike(id) {
            return unwrap(await client.DELETE('/v1/posts/{id}/like', { params: { path: { id } } }));
        },
        comments,
        iterateComments(id, query) {
            return paginate((page) => comments(id, page), query);
        },
        async addComment(id, text) {
            return unwrap(await client.POST('/v1/posts/{id}/comments', { params: { path: { id } }, body: { text } }));
        },
        async removeComment(commentId) {
            unwrapVoid(await client.DELETE('/v1/comments/{id}', { params: { path: { id: commentId } } }));
        },
    };
}
//# sourceMappingURL=posts.js.map